export default __webpack_public_path__ + "static/media/playlist.30e9ea47.svg";